// Base URL for API
export const API_BASE_URL = 'https://app.dobiqueen.my/api/v1';
// export const API_BASE_URL = 'http://dobiweb.test/api/v1';
